import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_BEGIN,
  MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_SUCCESS,
  MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_FAILURE,
  MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function fetchAddedSubsData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/getAddedSubstitutionsData`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchAddedSubsDataError() {
  return {
    type: MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_DISMISS_ERROR,
  };
}

export function useFetchAddedSubsData() {
  const dispatch = useDispatch();

  const { addedSubsData, fetchAddedSubsDataPending, fetchAddedSubsDataError } = useSelector(
    state => ({
      addedSubsData: state.manageSubs.addedSubsData,
      fetchAddedSubsDataPending: state.manageSubs.fetchAddedSubsDataPending,
      fetchAddedSubsDataError: state.manageSubs.fetchAddedSubsDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchAddedSubsData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchAddedSubsDataError());
  }, [dispatch]);

  return {
    addedSubsData,
    fetchAddedSubsData: boundAction,
    fetchAddedSubsDataPending,
    fetchAddedSubsDataError,
    dismissFetchAddedSubsDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchAddedSubsDataPending: true,
        fetchAddedSubsDataError: null,
      };

    case MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        addedSubsData: action.data,
        fetchAddedSubsDataPending: false,
        fetchAddedSubsDataError: null,
      };

    case MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchAddedSubsDataPending: false,
        fetchAddedSubsDataError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_ADDED_SUBS_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchAddedSubsDataError: null,
      };

    default:
      return state;
  }
}
